import { NetworkRequestState } from '../baseTypes';
import { AiContentWidgetData } from './types';

const defaultAiContentWidgetData: NonNullable<
  AiContentWidgetData['initialData']
> = {
  showAi: true,
};

export const defaultAiContentWidgetState: AiContentWidgetData = {
  initialData: defaultAiContentWidgetData,
  currentData: defaultAiContentWidgetData,
  isDirty: false,
  saveRequest: {
    status: NetworkRequestState.IDLE,
  },
};
